import { render, staticRenderFns } from "./ConfirmLevelUpDialog.vue?vue&type=template&id=18a525aa&scoped=true"
import script from "./ConfirmLevelUpDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmLevelUpDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmLevelUpDialog.vue?vue&type=style&index=0&id=18a525aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a525aa",
  null
  
)

export default component.exports